import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import { Text } from 'components/Text'
import {
  DoBetterRoot,
  DoBetterLayout,
  Title,
  Subtitle,
  Heading,
  HeadingTitle,
  ComparisonBox,
  OptionColumn,
  KibbleImage,
  RawFoodImage,
  FeaturesList,
  ButtonBox,
  Feature,
  ImageBox,
} from './DoBetter.styles'
import wfrBowl from '../../../../../public/assets/why-we-feed-raw/frozen-meat-bowl.webp'
import kibbleBowl from '../../../../../public/assets/why-we-feed-raw/kibble-bowl.webp'
import { Button } from 'components/Button'
import Link from 'next/link'

export const DoBetter = ({ compare = false }: { compare?: boolean }) => {
  const { t } = useTranslation()
  return (
    <DoBetterRoot>
      <DoBetterLayout>
        {compare ? (
          <Heading css={{ marginBottom: '0 !important' }}>
            <HeadingTitle>{t('recipes-overview:compare.title')}</HeadingTitle>
          </Heading>
        ) : (
          <Heading>
            <HeadingTitle>{t('why-we-feed-raw:intro.title')}</HeadingTitle>
            <Subtitle>{t('why-we-feed-raw:intro.description')}</Subtitle>
          </Heading>
        )}
        <ComparisonBox compare={compare}>
          <OptionColumn>
            <Title>{t('why-we-feed-raw:comparison.kibble.title')}</Title>
            <ImageBox className="kibble">
              <KibbleImage>
                <Image
                  layout="fill"
                  src={kibbleBowl}
                  alt={t('why-we-feed-raw:comparison.kibble.image')}
                />
              </KibbleImage>
            </ImageBox>
            <FeaturesList>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.kibble.features.0')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.kibble.features.1')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.kibble.features.2')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.kibble.features.3')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.kibble.features.4')}</Text>
              </Feature>
            </FeaturesList>
          </OptionColumn>
          <OptionColumn>
            <Title>{t('why-we-feed-raw:comparison.raw.title')}</Title>
            <ImageBox className="raw">
              <RawFoodImage>
                <Image src={wfrBowl} alt={t('why-we-feed-raw:comparison.raw.image')} />
              </RawFoodImage>
            </ImageBox>

            <FeaturesList>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.raw.features.0')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.raw.features.1')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.raw.features.2')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.raw.features.3')}</Text>
              </Feature>
              <Feature>
                <Text size="headline">{t('why-we-feed-raw:comparison.raw.features.4')}</Text>
              </Feature>
            </FeaturesList>
          </OptionColumn>
        </ComparisonBox>
        <ButtonBox>
          <Link passHref href="/meal-plan">
            <Button>{t('why-we-feed-raw:cta.button')}</Button>
          </Link>
        </ButtonBox>
      </DoBetterLayout>
    </DoBetterRoot>
  )
}

DoBetter.displayName = 'WhyWeFeedRawDoBetter'
